import { render } from "./CentralMessaging.vue?vue&type=template&id=3ae87700&ts=true"
import script from "./CentralMessaging.ts?vue&type=script&lang=ts&external"
export * from "./CentralMessaging.ts?vue&type=script&lang=ts&external"

import "./CentralMessaging.scss?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__